import Vue from 'vue';
import { socketStream } from '../../model/socket-stream.js';
import { accountEvents } from '../../model/accountevents.js';

export default {
	namespaced: true,
	state: {
        positions: {},
		page: 0,
        total: 0,
		pageLength: 50
	},
	mutations: {
		replaceAllItems(state, data) {
			Vue.set(state, 'positions', data);
        },
        replaceHoldAllItems(state, data) {
            Vue.set(state, 'holdPositions', data);
        },
		setPage(state, payload) {
	    	state.page = payload;
	    },
	    setPageLength(state, payload) {
	    	state.pageLength = payload;
	    },
	    setTotal(state, payload) {
	    	state.total = payload;
        }
	},
	getters: {
		getPositions(state) {
			return state.positions;
        },
	    getPage(state) {
	    	return state.page;
	    },
	    getPageLength(state) {
	    	return state.pageLength;
	    },
	    getTotal(state) {
	    	return state.total;
	    }
	},
	actions: {
		// query: { pageLength: 50, page: 1, symbol: 'EUR*' }
		readPositionsFromServer(state, query) {
			state.commit('setPage', query.page);
			state.commit('setPageLength', query.pageLength);
			let subMsg = JSON.stringify({
				ClassName: "ClosedPositionsSubscription",
				PageLength: query.pageLength,
				SkipCount: query.pageLength * query.page,
				SymbolFilter: query.symbol
			});
			socketStream.addChannelHandler('ClosedPositions', 'ClosPosStore', (data) => {
                let total = data[0];
				let positions = parsePositionsArray(data[1]);
				state.commit('replaceAllItems', positions);
				state.commit('setTotal', total);
			});
			socketStream.subscribeOnConnect(() => {
				socketStream.socket.send(subMsg);
			});
        }
	}
}

function parsePositionsArray(arrayOfArrays) {
	// [{id},\"{symbol}\",{side},{volume},{priceEnter},{curPrice},{resultDepo},{resultPoint},\"{timeEnter:yyyy.MM.ddTHH:mm:ss}\",\"{timeExit:yyyy.MM.ddTHH:mm:ss}\",{sl},{tp}]
	let positions = [];
	for (let i = 0; i < arrayOfArrays.length; i++) {
	  	let ar = arrayOfArrays[i];
	  	let pos = {
			id: ar[0],
			symbol: ar[1],
			side: ar[2],
			volume: ar[3],
			priceEnter: ar[4],
			curPrice: ar[5],
			resultDepo: ar[6],
			resultPoint: ar[7],
			timeEnter: ar[8],
			timeExit: ar[9],
			sl: ar[10],
			tp: ar[11]
	  	};
	  	positions.push(pos);
	}
	return positions;
  }